import React from 'react'
import styled from 'styled-components'
import { THEME } from './globalStyles';

export default function ShadowCard({children,onClick,clickable,selected, ...rest}){
  return (
    <Container {...rest} selected={selected}>
      {clickable?
        <Pressable onClick={onClick}>
          {children}
        </Pressable>
      :
        children
      }
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: fit-content;
  padding: 10px 8px 16px 8px;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: ${p=>p.selected?'2px solid'+THEME.colors.blue+'77':'2px solid #0000'};
  background-color: #FFF;
  box-shadow: 0px 0px 10px 1px rgba(230,230,230,0.65);
  z-index: 1;
`;
const Pressable = styled.button`
  width: 100%;
  border: none;
  background: none;
  text-align: left;
  cursor: 'pointer';
`;